import React, { useEffect, useState } from "react";
import moment from "moment";
import TodoForm from "./TodoForm";
import TodoItem from "./TodoItem";
import Checkbox from "../common/form/Checkbox";
import { fetchJson, post } from "../../lib/Fetching";

export default function Todos({ sample_id, clientView, onChange })
{
  const [todos, setTodos] = useState(false);

  const fetchTodos = () =>
    fetchJson("/registration/samples/" + sample_id + "/todos").then(json => {
      if (json.error) alert(json.error);
      else setTodos(json);
    });

  const handleTodoSubmit = todo =>
    post("/registration/samples/" + sample_id + "/todos", todo)
      .then(fetchTodos)
      .then(onChange)
      .catch(error => alert(error));

  const handleUpdateTodoCompleted = id => {
      post(
        "/registration/samples/" + sample_id + "/todos/" + id + "/update_completed",
        {},
        "PUT"
      )
        .then(fetchTodos)
        .then(onChange)
        .catch(error => alert(error));
    };

  const handleExpireTodo = id => {
    if (confirm(I18n.t("are_you_sure_you_want_to_delete_this_todo"))) {
    post("/registration/samples/" + sample_id + "/todos/" + id, {}, "DELETE")
      .then(fetchTodos)
      .then(onChange)
      .catch(error => alert(error));
    }
  };

  useEffect(() => {
    fetchTodos();
  }, [sample_id]);

  return (
    <div className="todos">
      <h4>Todos</h4>
      {todos && todos.length === 0 && <p>{I18n.t("you_can_assign_todos")}</p>}
      <ul>
        {todos && (todos.map(todo => (
          <TodoItem
            key={todo.id}
            todo={todo}
            sample_id={sample_id}
            handleExpireTodo={handleExpireTodo}
            handleUpdateTodoCompleted={handleUpdateTodoCompleted}
          />
        )))}
      </ul>
      <div>
        <TodoForm handleTodoSubmit={handleTodoSubmit} clientView={clientView} />
      </div>
    </div>

  );
}
